// extracted by mini-css-extract-plugin
module.exports = {"container":"add-answer_container__3Oaus","textarea":"add-answer_textarea__F6-Fr","status":"add-answer_status__3UUiI"};